import { addResourceBundle } from '@egw/i18n'
import en from './src/i18n/locales/en.json'

addResourceBundle('en', 'features-holdings', en)

export * from './src/components'
export * from './src/pages/account-holdings'
export * from './src/pages/account-holdings-details'
export * from './src/pages/allocation-holdings-details'
export * from './src/pages/allocation-holdings-list'
export * from './src/pages/companion-account-holdings'
export * from './src/pages/companion-account-holdings-details'
export * from './src/pages/overview'
